import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {OpenableModals, useOpenableModal} from '../../../../openable-modals';

import {ChangeStatus, StatusInfo} from './pages';

export function AgentStatusInfoModal() {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.AGENT_STATUS_INFO_MODAL);

    const pages = [
        {
            id: 'status-info',
            body: <StatusInfo />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper image={<Illustration src='nav-agent-status' />} width={190} />
                ),
            },
        },
        {
            id: 'change-status',
            body: <ChangeStatus />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <div className='full-width full-height pad-16 border-box align-center justify-center flex'>
                        <img
                            src='/include/images/chat/change-status.png'
                            alt='Change Status'
                            className='full-width'
                        />
                    </div>
                ),
            },
        },
    ];

    return (
        isOpen && (
            <OnboardingModal
                trapFocus={false}
                lastButtonText='Done'
                pages={pages}
                onClose={onClose}
                onFinish={onClose}
                canClickOutsideToClose={false}
            />
        )
    );
}
